// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1916K","top":"styles_top__woLVb","left":"styles_left__UiC4P","description":"styles_description__3zGmZ"};